<template>
    <b-modal id="change-bid" title="Change bid" @ok="changeBid" ref="changeBidModal">
        <div class="item-place-bid">
            <div class="title-place-bid">
                Estimated Landed Cost
            </div>
            <div class="form-group inline-label">
                <label for="change-bid-landed" style="text-transform: uppercase">
                    {{ user_currency_code }} {{user_currency_sign}}
                </label>
                <input id="change-bid-landed" ref="changeBidLanded" type="text" name="estimatedLandedCost" value=""
                       placeholder="12,345" v-model="estimatedLandedCost"
                       @input="onLandedCostInput">
            </div>
        </div>
        <div class="item-place-bid">
            <div class="title-place-bid">
                Place Bid (in thousands of yen)
            </div>
            <div class="form-group inline-label">
                <label for="change-bid-jpy">JPY ¥</label>
                <input id="change-bid-jpy" type="text" value="" placeholder="220"
                       v-model="bidPriceProxy" @input="onBidPriceInput">
            </div>
        </div>
        <div class="item-place-bid" v-if="$userIsAdmin()">
            <div class="title-place-bid">
                Bump Bid
            </div>
            <div class="form-group inline-label">
                JPY ¥ {{numberWithCommas(bumpBid)}}
            </div>
        </div>
    </b-modal>
</template>
<script>
    import {handleHttpError, numberWithCommas, objLookup} from '../../util/common'
    import {getYenFromLanded, getLandedCost} from '../../util/bid_helper'
    import {mapState} from "vuex";
    export default {
        props: [
        ],
        created(){
        },
        mounted(){
        },
        data() {
            return {
                estimatedLandedCost: '',
                bidPrice: 0,
                bumpBid: 0,
                bidPriceProxy: null,
                fees: this.loggedInUser.pricing_rule || this.defaultPricing,
            }
        },
        computed: {
            ...mapState({
                user_currency_code: state => state.currency.user_currency_code,
                user_currency_sign: state => state.currency.user_currency_sign,
            }),
        },
        methods: {
            numberWithCommas,
            openModal(bid){
                this.$refs.changeBidModal.show();
                this.fees = bid.user.pricing_rule || this.defaultPricing;
                this.change_bid_id = bid.id;
                this.estimatedLandedCost = bid.bid_price_landed;
                this.bumpBid = bid.bump_bid;
                this.onLandedCostInput();
                setTimeout(()=>{
                    this.$refs.changeBidLanded.focus();
                    this.$refs.changeBidLanded.select();
                }, 200);
            },
            onBidPriceInput() {
                this.bidPrice = this.bidPriceProxy * 1000;
                try{
                    this.estimatedLandedCost = getLandedCost(this.bidPrice, this.fees, this.user_currency_code);
                } catch (e) {
                    this.onBidError(e)
                }
            },
            onLandedCostInput() {
                try{
                    let yen = getYenFromLanded(this.estimatedLandedCost, this.fees, this.user_currency_code);
                    if (yen > 0) {
                        this.bidPriceProxy = yen / 1000;
                        this.bidPrice = yen;
                    } else {
                        this.bidPriceProxy = '';
                        this.bidPrice = 0;
                    }
                } catch (e) {
                    this.onBidError(e)
                }
            },
            onBidError(e){
                this.$message.error('There was a problem calculating your bid. Please refresh the page and try again.')
                console.warn(e)
                this.bidPriceProxy = '';
                this.bidPrice = 0;
                this.estimatedLandedCost = ''
            },
            changeBid() {
                if (this.estimatedLandedCost > 49100 && this.$userIsDealer()) {
                    this.$confirm('Please be aware that an immediate additional cash payment is required on confirmation of this purchase should your bid be successful', 'Warning', {
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(() => {
                        this.submitChangeBid()
                    }).catch(() => {
                        //they clicked cancel
                    });
                } else {
                    this.submitChangeBid()
                }
            },
            async submitChangeBid(){
                let bid_id = this.change_bid_id;
                let landed = this.estimatedLandedCost;
                this.change_bid_id = null;
                this.estimatedLandedCost = null;
                this.bidPrice = 0;
                this.bumpBid = 0;
                this.bidPriceProxy = '';
                try {
                    let result = await this.$store.dispatch('userBids/changeBid', {
                        id: bid_id,
                        landed_price: landed,
                        message: '',
                    });
                    if (result && result.message) {
                        this.$emit('changed', bid_id, result.message, result);
                    }
                } catch (e) {
                    handleHttpError(e);
                }
            }

        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/VehicleSingle/ChangeBid.vue